export { getStoresServerAction } from 'next-flight-server-reference-proxy-loader?id=7075932d13d0682dc2024cb4b7c7d5353c11f9c1ea&name=getStoresServerAction!'